<div class="inner-timeline"></div>
<div class="size-overlay" (click)="DecreaseTimeScaleOrReset()">
  <svg class="btn-icn"><use href="assets/icons.svg#icn-calendar" /></svg>{{GetTimeScaleName()}}
</div>
